/* TFG footer custom behaviour
   Asset: tfg-footer-custom.js
   Used by: Footer section
*/

(function () {
  function defineFooterMenu() {
    if (customElements.get('footer-menu')) return;

    if (typeof DetailsDisclosure === 'undefined') {
      return;
    }

    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset = this.reset.bind(this);
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset);
      }

      reset() {
        const mediaQuery = window.theme && window.theme.mediaQueries
          ? window.theme.mediaQueries.md
          : '(min-width: 769px)';

        const isLargeScreen = window.matchMedia(mediaQuery).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  }

  if (customElements.get('details-disclosure')) {
    defineFooterMenu();
  } else {
    customElements.whenDefined('details-disclosure').then(defineFooterMenu).catch(function () {});
  }
})();
